const milestones = [
  { year: "Founded", desc: "Born as a team of passionate iOS engineers with a vision for privacy-first apps." },
  { year: "First App", desc: "Launched our flagship VPN product, setting a new standard for iOS security." },
  { year: "Expanded", desc: "Released the Cleaner app, rounding out our suite of device-optimization tools." },
  { year: "Today", desc: "Trusted by users across Europe and beyond, continuously refining our products." },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-[#0a0a0a] py-32 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Section label */}
        <div className="flex items-center gap-3 mb-6">
          <span className="w-8 h-0.5 bg-emerald-400" />
          <span className="text-emerald-400 text-xs font-semibold tracking-widest uppercase">
            About Us
          </span>
        </div>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left — text */}
          <div>
            <h2
              className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Engineering Excellence
              <br />
              <span className="text-emerald-400">for the iOS Platform</span>
            </h2>
            <p className="text-gray-400 text-base leading-relaxed mb-8 max-w-lg">
              JEKO, d.o.o. is a Slovenian team of experts dedicated to crafting
              modern, high-performance applications for iOS. We believe that
              security and performance should never be a compromise — so we
              engineer products that deliver both, seamlessly.
            </p>
            <p className="text-gray-400 text-base leading-relaxed max-w-lg">
              From our headquarters in Jesenice, we combine deep platform
              knowledge with a user-centered design philosophy to build apps
              that genuinely improve everyday digital life.
            </p>

            {/* Milestones */}
            <div className="mt-12 space-y-6">
              {milestones.map((m) => (
                <div key={m.year} className="flex gap-5">
                  <div className="flex-shrink-0 w-24 text-emerald-400 font-semibold text-sm mt-0.5">
                    {m.year}
                  </div>
                  <div className="text-gray-400 text-sm leading-relaxed">
                    {m.desc}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — image stack */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden w-full">
              <img
                src="https://public.readdy.ai/ai/img_res/ffefc43217842f9570d042158e9a07d9.jpg"
                alt="JEKO team workspace"
                className="w-full h-80 object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 rounded-2xl overflow-hidden w-48 h-48 border-4 border-[#0a0a0a]">
              <img
                src="https://readdy.ai/api/search-image?query=close%20up%20iPhone%20iOS%20application%20development%20code%20interface%20dark%20minimal%20background%20emerald%20green%20accent%20lines%20premium%20sleek%20professional%20tech%20aesthetic%20modern%20software%20engineering%20screen&width=400&height=400&seq=jeko-about-img-002&orientation=squarish"
                alt="iOS development"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -top-4 -left-4 w-24 h-24 rounded-full border border-emerald-400/20" />
            <div className="absolute -top-8 -left-8 w-40 h-40 rounded-full border border-emerald-400/10" />
          </div>
        </div>
      </div>
    </section>
  );
}
